<script lang="ts">
</script>

<div class="grid-row padding-bottom--small">
  <div class="grid-col c6-12 vertical-align-middle">
    <span class="default-title--regular margin-bottom--smaller show--md">Custom Pricing</span>
  </div>
</div>
